module.exports = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/view/home'),
    meta: {
      title: 'menu.home',
      menu: 'home'
    },
  },
  {
    path: 'info',
    component: () => import('@/view/info'),
    meta: {
      title: 'menu.info',
      menu: ''
    },
  },
  {
    path: 'log',
    component: () => import('@/view/log'),
    meta: {
      title: 'menu.log',
      menu: 'log'
    },
  },
  {
    path: 'bill',
    component: () => import('@/view/bill'),
    meta: {
      title: 'menu.bill',
      menu: 'bill'
    },
  },
  {
    path: 'ticket',
    name: 'ticket',
    component: () => import('@/view/ticket'),
    meta: {
      title: 'menu.ticket',
      menu: 'ticket'
    },
  },
  {
    path: 'address',
    name: 'address',
    component: () => import('@/view/address'),
    meta: {
      title: 'menu.address',
      menu: 'address'
    },
  },
  {
    path: 'cex',
    component: () => import('@/view/cex'),
    meta: {
      title: 'menu.cex',
      menu: 'cex'
    },
  },
  {
    path: 'cex/order',
    component: () => import('@/view/cexOrder'),
    meta: {
      title: 'menu.cex_order',
      menu: 'cex-order'
    },
  },
  {
    path: 'cex/take',
    component: () => import('@/view/cexTake'),
    meta: {
      title: 'menu.cex_take',
      menu: 'cex-take'
    },
  }
]